import { describeApiError, getApiErrorCode } from '@/lib/api-errors';

/**
 * What to show when pricing fails: a coded refusal names its reason in the
 * shop language (quote_size_unknown, quote_quantity_out_of_range, ...);
 * anything else keeps the generic `fallback` line.
 */
export function describeQuoteError(error: unknown, fallback: string): string {
  return getApiErrorCode(error) ? describeApiError(error) : fallback;
}
